import { useContext } from 'react';
import { resizeImage } from '../components/common/helpers/resizeImage';
import { MeContext } from '../contexts/me.context';
import uploadService from '../services/upload.service';

const useUpload = () => {
  const meContext = useContext(MeContext);

  const upload = ({
    category,
    type,
    file,
    publicFile,
  }: {
    category: string;
    type: 'video' | 'image' | 'pdf' | 'file';
    file: any;
    // Public file = false only works for images atm - all videos are public
    publicFile?: boolean;
  }) => {
    return uploadService.upload({
      clinicId: Number(meContext?.me?.selectedClinic?.ID || -1),
      userId: meContext?.me?.ID,
      category: category,
      type: type,
      file: file,
      publicFile,
    });
  };

  const autoCropUpload = async ({
    file,
    extension,
    uploadCategory,
    uploadType,
    publicFile,
  }: {
    file: any;
    extension: any;
    uploadCategory: string;
    uploadType: 'video' | 'image' | 'pdf' | 'file';
    // Public file = false only works for images atm - all videos are public
    publicFile?: boolean;
  }) => {
    const config = {
      file,
      maxSize: 1000,
      extension,
    };
    file = await resizeImage(config);
    return await upload({
      category: uploadCategory,
      type: uploadType,
      file,
      publicFile,
    });
  };

  const getStatus = (file: string) => {
    return uploadService.status(meContext?.me?.selectedClinic?.ID, file);
  };

  return {
    upload,
    getStatus,
    autoCropUpload,
  };
};

export default useUpload;
